import { Alert } from '@material-ui/lab';

import { GraphQLAppError } from '@spotify/confidence-graphql';

import { useDialogContext } from '../DialogComposite/context';

export const SubmitError = () => {
  const { error } = useDialogContext();
  if (!error) return null;
  const title =
    error instanceof GraphQLAppError
      ? (error.enrichedMessage ?? error.message)
      : error.message;
  return <Alert severity="error">{title}</Alert>;
};

SubmitError.displayName = 'DialogComposite.SubmitError';

export default SubmitError;
